import React, { Component } from 'react';
import Modal from '../modal/modal';

import './uploading-modal.css';

class UploadingModal extends Component {
    render() {
        return (
            <Modal show={ this.props.show } onClose={ ()=> null }>
                <div className='upload-modal-body'>
                    <section className='show-upload'>
                        <section className={'icons-wrapper'}>
                            <i className='fa fa-cloud' />
                            <i className='fa fa-arrow-up arrow-animated' />
                        </section>
                        <section className='text-wrapper'>
                            <h5>Enviando...</h5>
                        </section>
                    </section>
                </div>
            </Modal>
        );
    }
}

export default UploadingModal;



// WEBPACK FOOTER //
// ./src/components/uploading-modal/uploading-modal.js